import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
// @ts-ignore
import toneIcon from '../../image-assets/icon.tone.svg';
// @ts-ignore
import tasksIcon from '../../image-assets/icon.tasks.svg';
// @ts-ignore
import searchIcon from '../../image-assets/icon.search.svg';
// @ts-ignore
import teamIcon from '../../image-assets/icon.profile.svg';
import './NavMenu.css';

const menuTabs = [
  { id: 'overview', label: 'Overview', path: '/app/overview', icon: searchIcon },
  { id: 'reviews', label: 'Reviews', path: '/app/reviews', icon: tasksIcon },
  { id: 'team', label: 'Team', path: '/app/team', icon: teamIcon },
  { id: 'tone', label: 'Tone', path: '/app/tone', icon: toneIcon }
];

const NavMenu: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;

  return (
    <div className="nav-menu">
      {menuTabs.map((tab) => (
        <div
          key={tab.id}
          onClick={() => navigate(tab.path)}
          className={`nav-tab ${currentPath === tab.path ? 'nav-tab-selected' : ''}`}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              navigate(tab.path);
            }
          }}
        >
          <img src={tab.icon} alt="" className="nav-tab-icon" />
          <span>{tab.label}</span>
        </div>
      ))}
    </div>
  );
};

export default NavMenu; 